import React, { Component } from 'react';
import styles from './auth.module.scss';

const CODE_LENGTH = 6;

export default class SixDigitInput extends Component
{
    constructor(props)
    {
        super(props);
        
        this.state =
        {
            code: [],
            focusedInputNumber: null
        }
        
        for (let i = 0; i < CODE_LENGTH; i++)
        {
            this.state.code.push('');
        }
    }
    
    render()
    {
        const inputs = []
        for (let i = 1; i < CODE_LENGTH+1; i++)
        {
            let inputIsFocused = (this.state.focusedInputNumber === i);
            
            inputs.push(
                <input
                    key={`${i}`}
                    className={styles.sixDigitInput}
                    ref={`input${i}`}
                    value={this.state.code[i-1]}
                    autoFocus={(this.props.focusOnMount == null || this.props.focusOnMount) && (i === 1)}
                    onFocus={() => this.onInputFocus(i)}
                    onBlur={() => this.onInputBlur()}
                    onChange={(event) => this.onInputChangeText(i, event)}
                    onKeyPress={(event) => this.onInputKeyPress(i, event)}
                />
            );
        }

        return (
            <div>
                { inputs }
            </div>
        );
    }
    
    onInputFocus(inputNumber)
    {
        this.setState({ focusedInputNumber: inputNumber });
    }
    onInputBlur()
    {
        this.setState({ focusedInputNumber: null });
    }
    onInputChangeText(inputNumber, event)
    {    
        let code = [...this.state.code]
        let text = event.target.value;

        if (text.length > 0)
        {
            if (text.length === 1)
            {
                code[inputNumber-1] = text;
                
                if (this.refs[`input${inputNumber+1}`] != null)
                    this.refs[`input${inputNumber+1}`].focus();
                else if (this.refs[`input${inputNumber}`] != null)
                    this.refs[`input${inputNumber}`].blur();
            }
            else if (text.length === CODE_LENGTH && inputNumber === 1)
            {
                for (let i = 0; i < text.length && i < 6; i++)
                {
                    code[i] = text.charAt(i);
                    this.refs[`input${i+1}`].blur();
                }
            }
        }
        else
        {
            code[inputNumber-1] = '';
        }
        this.setState({ code }, () =>
        {
            let codeStr = this.getCodeString();
            if (this.props.onCodeChanged != null)
                this.props.onCodeChanged(codeStr);
            if (codeStr.length === CODE_LENGTH && this.props.onCodeFilled != null)
            {
                this.props.onCodeFilled();
            }
        });
    }
    onInputKeyPress(inputNumber, event)
    {
        if (event.nativeEvent.key == 'Backspace')
        {
            if ((this.state.code[inputNumber-1] + '').length === 0)
            {
                if (this.refs[`input${inputNumber-1}`] != null)
                    this.refs[`input${inputNumber-1}`].focus();
            }
        }
    }
    
    getCodeString()
    {
        let codeStr = '';
        
        for (let i = 0; i < CODE_LENGTH; i++)
        {
            codeStr += this.state.code[i];
        }
        
        return codeStr;
    }
    
    clearCode()
    {
        let code = []
        for (let i = 0; i < CODE_LENGTH; i++)
        {
            code.push('');
        }
        
        this.setState({ code }, () =>
        {
            if (this.refs['input1'] != null)
                this.refs['input1'].focus();
        });
    }
}